import $ from 'jquery';

import './c-box-el.scss';
import template from './box-el.vhtml';

export default {
	template,
	props: {
		color: {
			type: String,
			default: '',
		},
		noHeader: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			isSelected: false,
			elHeight: 0,
		};
	},
	mounted() {
		this.elHeight = this.$el.lastElementChild.offsetHeight;
	},
	methods: {
		selectEl() {
			( this.isSelected === true ) ? this.isSelected = !this.isSelected: this.$emit( 'selected', this._uid );
		},
	},
	watch: {
		isSelected() {
			if ( this.isSelected ) {
				$( '.js-slide-down-up', this.$el ).slideDown( 400 );
			} else {
				$( '.js-slide-down-up', this.$el ).slideUp( 400 );				
			}
		},
	},
};



// WEBPACK FOOTER //
// ./assets/_js/components/box-el/box-el.js